import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import {
  OnReceiveSocketSubscriptionsEvent,
  SubscriptionsSocketMessage,
} from './types';

export function useSubscriptionsUpdateSocketListener(
  onEvent: OnReceiveSocketSubscriptionsEvent
) {
  const channel = useGetSocketChannel(SocketMessageType.SUBSCRIPTION);

  useSocketEvent(channel, (data: SubscriptionsSocketMessage) => {
    if (data.type === SocketMessageType.SUBSCRIPTION) onEvent(data);
  });
}
